(function (): void {
    function cookieImg(): void {
        document.querySelectorAll<HTMLElement>(".js-calendar-block").forEach((block) => {
            const img = block.querySelector<HTMLImageElement>(
                ".cookieconsent-optout-marketing picture img"
            );
            const iframe = block.querySelector<HTMLIFrameElement>(
                ".Iframe_container .cookieconsent-optin-marketing iframe"
            );
            if (img && iframe) {
                iframe.style.backgroundImage = `url(${img.getAttribute("src")})`;
            }
        });
    }

    window.addEventListener("load", cookieImg);
})();
